import Errors from './Errors';

class Table {

	constructor(data) {
        this.originalData = data;

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
    }


    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        this.unfiltered = data.slice(0);

        return data;
    }

    reset() {
        console.log(this.unfiltered);
    }

    fetch(url, field) {
    	axios.get(url)
    		.then(response => this[field] = response.data);
    }

    sortByValue(dataset, key, reverse) {
    	this[dataset].sort((a, b) => {
    		if (reverse) {
                return b[key] - a[key];
            }
            return a[key] - b[key];
    	});

    }

    filterBy(dataset, field, key) {

    }

    destroy(dataset, item) {
        swal({
            title: "Sei sicuro?",
            text: "Potresti generare un casino inenarrabile!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Fottesega! Cancella!'
        }).then(() => {
            axios.delete('/items/' + item.id_articolo)
                .then(() => {
                    this[dataset].splice(this[dataset].indexOf(item), 1);    
                })
                .catch((error) => {
                    swal('Disastro!', 'Hai fatto un casino!!', 'error');
                })
            
        });      
    }

    sortByString(dataset, key, reverse) {
        
    	this[dataset].sort((a, b) => {
    		var stringA = a[key].toUpperCase();
    		var stringB = b[key].toUpperCase();

    		if (stringA < stringB) {
    			if (reverse) {
                    return 1
                }
                return -1;
    		}
    		if (stringA > stringB) {
                if (reverse) {
                    return -1;
                }
    			return 1;
    		}

    		return 0;
    	});
    }
}

export default Table;